import React from 'react';
import './morevalueadds.css';
import leads from '../icons/leads.png';
import domain from '../icons/domain.png';
import membership from '../icons/membership.png';


const MoreValueAdds = () => {
  return (
    <div className="more-value-adds container my-3">
      <h2 className="mb-4">More Value Adds</h2>
      <div className="value-adds-grid">
      
          <a href="" className="value-add-card">
            <div className="icon-wrapper">
              <img src={leads} alt="" />
            </div>
            <p> Buy Trade Leads</p>
            <span className="learn-more">Learn more →</span>
          </a>
            <a href="" className="value-add-card">
            <div className="icon-wrapper">
              <img src={domain} alt="" />
            </div>
            <p> Book Domain</p>
            <span className="learn-more">Learn more →</span>
          </a>
            <a href="" className="value-add-card">
            <div className="icon-wrapper">
              <img src={membership} alt="" />
            </div>
            <p>Membership Plans</p>
            <span className="learn-more">Learn more →</span>
          </a>
       
      </div>
    </div>
  );
};

export default MoreValueAdds;
